import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetSearchGame = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_SEARCH_GAMES
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetSearchGameAction(data.data))
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetSearchGame as SetGetSearchGame
}